import { api } from "common"

export const CLINICS_URL = {
  createClinic: `${api.withAPI}api/clinic`,
  getClinics: `${api.withAPI}api/clinic`,
}
